import React, { memo } from 'react'

import { Icon, RotatingSpinner } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSizeXLarge } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function SearchLoading() {
  const t = useTranslation()

  return (
    <div className="image-assistant-search-tab__state">
      <Icon svgComponent={RotatingSpinner} size={iconSizeXLarge} color="primary" notSpaced />
      <p className="image-assistant-search-tab__state-title cgt-heading-200">
        {t('imageAssistantPanel.searchTab.loading')}
      </p>
    </div>
  )
}

export default memo(SearchLoading)
